// © Microsoft Corporation. All rights reserved.
/**
 * used query string params in Wpo requests
 */
export const WpoQueryStringKeys = {
    activityId: "activityId",
    apiKey: "apikey",
    audienceMode: "audienceMode",
    bypassTrigger: "bypass_trigger",
    complexInfoPaneEnabled: "cipenabled",
    contentType: "contentType",
    delta: "delta",
    disableTypeSerialization: "DisableTypeSerialization",
    infopaneCount: "infopaneCount",
    fdhead: "fdhead",
    feedLayoutRequestType: "t",
    filter: "$filter",
    ids: "ids",
    interestIds: "interestids",
    location: "location",
    market: "market",
    ocid: "ocid",
    pageConfiguration: "pgc",
    parentContentId: "parent-content-id",
    parentNamespace: "parent-ns",
    parentTitle: "parent-title",
    queryQ: "q",
    query: "query",
    queryType: "queryType",
    qScope: "qscope",
    responseSchema: "responseschema",
    select: "$select",
    session: "session",
    signInCookieName: "scn",
    skip: "$skip",
    source: "source",
    timeOut: "timeOut",
    top: "$top",
    type: "type",
    user: "user",
    wrapOData: "wrapodata",
    wpoitems: "wpoitems",
    wpoPageId: "wpopageid",
    wpoSchema: "wposchema"
};
/** Api Key */
export const APIKey4Wpo = "0QfOX3Vn51YCzitbLaRkTTBadtWpgTN8NZLW0C1SEM";
/** Feed URL Path */
export const WpoFeedUrlPath = "optimizer/api/anaheim/feed";
/** Feed URL Path for flight prg-ewebcomp-os */
export const WpoOneServiceFeedUrlPath = "news/feed/pages/wpodhp";
/** Feed endpoint path without pageId */
export const WpoOneServicePagePath = "service/news/feed/pages/";
/** Page id for X-Feed(Interest) page */
export const WpoOneServiceXFeedPageId = "wpoxfeed";
/** Page id for Myfeed(dhp) */
export const WpoOneServiceDhpPageId = "wpodhp";
/** Page id for NTP */
export const WpoOneServiceNtpPageId = "ntp";
export const WpoOneServiceSegmentPath = "news/feed/Segments";
/** Feed Base domain for flight prg-ewebcomp-os */
export const WpoOneServiceFeedBaseDomain = "https://assets.msn.com";
/** WPO Base domain for OneService cluster */
export const WPOBaseDomainForOneServiceCluster = "https://api.msn.com";
/** QS override value to use base request domain. For testing int environment changes. */
export const WPOUseBaseDomainQSOverride = "wpo-usebasedomain";
/** PPE api domain and path */
export const WPOIntEnableKey = "wpo-useintdomain";
export const WpoIntServiceFeedBaseDomain = "https://ppe-api.msn.com";
export const WpoIntServiceMyfeedPath = "news/feed/pages/wpodhp";
export const WpoIntServiceXfeedPath = "news/feed/pages/wpoxfeed";
/**
 * The fallback value to be used for infopane count query param if not present in market config.
 */
export const DefaultInfopaneCountValue = 17;
/**
 * specific query string for kid mode.
 */
export const ocidForChildMode = "msnkids";
export const apiKeyForChildWpo = "dy0rQcQaYj5cKZ2Cy0cdaRDJcC5maS5hPj9w2SbeRf";
export function initBaseRequestParameters4Wpo(request, requestQueryParams) {
    requestQueryParams
        .set(WpoQueryStringKeys.wrapOData, "false")
        .set(WpoQueryStringKeys.disableTypeSerialization, "true")
        .set(WpoQueryStringKeys.queryType, "myfeed")
        .set(WpoQueryStringKeys.timeOut, `${getRequestTimeout(request)}`)
        .set(WpoQueryStringKeys.contentType, request.contentType)
        .set(WpoQueryStringKeys.apiKey, APIKey4Wpo);
    if (!request.disableQueryType) {
        requestQueryParams.set(WpoQueryStringKeys.queryType, "myfeed");
    }
    if (request.useDelta || request.sessionId) {
        requestQueryParams.set(WpoQueryStringKeys.delta, "true");
        if (request.sessionId) {
            requestQueryParams.set(WpoQueryStringKeys.session, request.sessionId);
        }
    }
    if (request.ocid) {
        requestQueryParams.set(WpoQueryStringKeys.ocid, request.ocid);
    }
}
function getRequestTimeout(request) {
    const { timeoutMs, query, customFeedTimeoutMs } = request;
    // Use custom feed specific timeout when loading a custom feed
    // to alow higher timeouts if required to OneService when fetching
    // feed data straight from bing
    return query && customFeedTimeoutMs ? customFeedTimeoutMs : timeoutMs;
}
//# sourceMappingURL=WpoService.js.map